import { render, staticRenderFns } from "./AllotmentPreview.vue?vue&type=template&id=2e74f400&scoped=true&"
import script from "./AllotmentPreview.vue?vue&type=script&lang=js&"
export * from "./AllotmentPreview.vue?vue&type=script&lang=js&"
import style0 from "./AllotmentPreview.vue?vue&type=style&index=0&id=2e74f400&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e74f400",
  null
  
)

export default component.exports